import React from 'react';
import { User, Heart, CalendarDays } from 'lucide-react';

/**
 * Компонент с основными параметрами для расчета пульса
 */
const BaseParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Возраст */}
      <div>
        <label htmlFor="age" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CalendarDays className="w-4 h-4 mr-2 text-red-500" />
          Возраст (лет)
        </label>
        <input
          type="number"
          id="age"
          name="age"
          value={formData.age}
          onChange={handleInputChange}
          min="1"
          max="120"
          className={`form-input w-full ${errors.age ? 'input-error' : ''}`}
          placeholder="Введите возраст"
        />
        {errors.age && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.age}
          </p>
        )}
      </div>

      {/* Пол */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <User className="w-4 h-4 mr-2 text-red-500" />
          Пол
        </label>
        <div className="grid grid-cols-2 gap-3">
          <label className="flex items-center p-3 border rounded-lg cursor-pointer transition-colors 
            ${formData.gender === 'male' 
              ? 'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800' 
              : 'bg-gray-50 border-gray-200 dark:bg-gray-700 dark:border-gray-600'} hover:bg-gray-100 dark:hover:bg-gray-600">
            <input
              type="radio"
              name="gender"
              value="male"
              checked={formData.gender === 'male'}
              onChange={handleInputChange}
              className="form-radio hidden"
            />
            <span className={`ml-2 text-sm ${formData.gender === 'male' ? 'font-medium text-red-700 dark:text-red-300' : 'text-gray-700 dark:text-gray-300'}`}>
              Мужской
            </span>
          </label>
          <label className="flex items-center p-3 border rounded-lg cursor-pointer transition-colors 
            ${formData.gender === 'female' 
              ? 'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800' 
              : 'bg-gray-50 border-gray-200 dark:bg-gray-700 dark:border-gray-600'} hover:bg-gray-100 dark:hover:bg-gray-600">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={formData.gender === 'female'}
              onChange={handleInputChange}
              className="form-radio hidden"
            />
            <span className={`ml-2 text-sm ${formData.gender === 'female' ? 'font-medium text-red-700 dark:text-red-300' : 'text-gray-700 dark:text-gray-300'}`}>
              Женский
            </span>
          </label>
        </div>
        {errors.gender && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.gender}
          </p>
        )}
      </div>

      {/* Пульс в покое */}
      <div className="col-span-full">
        <div className="flex items-center mb-2">
          <label htmlFor="includeRestingHR" className="flex items-center">
            <input
              type="checkbox"
              id="includeRestingHR"
              name="includeRestingHR"
              checked={formData.includeRestingHR}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Учитывать пульс в покое (метод Карвонена)
            </span>
          </label>
        </div>
        
        {formData.includeRestingHR && (
          <div className="mt-2">
            <label htmlFor="restingHeartRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Heart className="w-4 h-4 mr-2 text-red-500" />
              Пульс в покое (уд/мин)
            </label>
            <input
              type="number"
              id="restingHeartRate"
              name="restingHeartRate"
              value={formData.restingHeartRate}
              onChange={handleInputChange}
              min="30"
              max="150"
              className={`form-input w-full ${errors.restingHeartRate ? 'input-error' : ''}`}
              placeholder="Введите частоту пульса в состоянии покоя"
            />
            {errors.restingHeartRate && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.restingHeartRate}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Формула Карвонена обеспечивает более точный расчет целевых зон пульса с учетом вашего пульса в покое.
              Измерьте пульс утром после пробуждения или после 10 минут полного покоя.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BaseParametersSection;